<template>
  <div class="card">
    <div class="video-asset-agenda-header">
      <h2 class="video-asset-agenda-title">
        {{item.scheduleItem.name}}
      </h2>
      <div class="video-asset-detail-page" v-if="item.scheduleItem.detail_page">
        <a class="video-asset-detail-page-link" :href="getDetailPage(item.scheduleItem.id)">
          <span class="video-asset-detail-page-link-text">
            {{ lang.get('event_strings.agenda.detail_link_text') }}
          </span>
          <i class="far fa-arrow-right ml-1"></i>
        </a>
      </div>
    </div>
    <!-- Agenda Date / Times -->
    <div class="video-asset-agenda-details">
      <div class="video-asset-agenda-date video-asset-agenda-icon">
        <i class="far fa-calendar"></i>
        {{ item.scheduleItem.formatted_date }}
      </div>
      <div class="video-asset-agenda-times video-asset-agenda-icon">
        <i class="far fa-clock"></i>
        {{ item.scheduleItem.formatted_times }}
      </div>
      <!-- Locations -->
      <div class="video-asset-agenda-locations video-asset-agenda-icon" v-if="item.scheduleItem.locations.length">
        <i class="far fa-map-marker-alt"></i>
          <span class="video-asset-agenda-location-location-name"
            v-for="(videoAssetAgendaLocation, index) in item.scheduleItem.locations"
            v-if="videoAssetAgendaLocation.name != 'zzz' && videoAssetAgendaLocation.name != 'ZZZ'">
              {{ videoAssetAgendaLocation.name }}<span v-if="index != item.scheduleItem.locations.length - 1">, </span>
          </span>
      </div>
    </div>

    <!-- Description -->
    <div class="video-asset-agenda-description" v-html="item.scheduleItem.description"></div>

    <!-- Speaker Sections -->
    <div class='video-asset-speaker-section' v-if="item.sections.length">
      <div class="pb-1" v-for="(agendaItemSpeakerSection, index) in item.sections" :key="index">
        <div class='video-asset-speaker-section-name'>
          {{ agendaItemSpeakerSection.name }}
        </div>
        <!-- Speakers -->
        <VideoAssetSpeaker 
          v-for="(speaker, i) in agendaItemSpeakerSection.speakers" 
          :speaker="speaker" 
          :key="i"
        />
      </div>
    </div>

    <!-- Agenda Tags -->
    <div class="video-asset-agenda-tags">
      <div v-for="(tag, index) in item.tags" 
        class="badge tag-badge agenda__item-tag" 
        v-show="tag.visible" 
        :style="`background-color: ${tag.tag_hex};`" 
        :key="index"
      >
        {{ tag.tag }}
      </div>
    </div>

    <!-- Like session -->
        <div class="agenda__item-likeable-item" v-if="item.scheduleItem.is_likeable" v-cloak>
        <likeable-item
          :plugin-type="'ScheduleItem'"
          :plugin="item.scheduleItem"
          aria-label="Did you like this session?"
          tabindex="0"
          ></likeable-item>
    </div>
    <!-- /Like session -->
  </div>
</template>

<script>

import VideoAssetSpeaker from './VideoAssetSpeaker.vue'

export default {
  components: {
    VideoAssetSpeaker
  },

  props: {
    item: Object
  },

  methods: {
    getDetailPage (agendaId) {
      return '/schedule/'+agendaId+'/detail'
    }
  }
}


</script>

